import React ,{ useEffect, useState } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import { rquestions } from "../../apis/urls";
import axios from "axios";
import {decode} from 'html-entities';
import { $ } from "react-jquery-plugin";


const RulesQuestionList =()=> {

    useEffect( ()=> {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        QuestionListing();
    },[])


    const { id } = useParams();
    // let navigate = useNavigate();

    
    let navigate = useNavigate();


    const [result,setResult] = useState([]);
    const [rname,setRname] = useState('');
    const [tmark,setTmark] = useState('');



    const QuestionListing = () => {

        

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: rquestions+"/"+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data); 
            setRname(response.data.rule_name) 
            setTmark(response.data.mark)
            console.log('resultssssss',response.data)
                     
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }



    const DeleteQuestion = (rid) => {
        let r = window.confirm("Are you sure you want to delete this Question?");

        if(r === true){

            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: rquestions+'/'+rid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                QuestionListing();
                navigate("/rules_list_question/"+id)
            
            }).catch((error) =>{
                
                console.log('error',error.message)
                alert("Cannot delete")

            });
        }
    }
    
    let sl =1
    return(<>
             <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Manage Questions - {decode(rname)} </h2>
                        </div>
                        <div class="page-rightside-action-column">
                            <Link to={"/create_quest/"+id} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add Question</span> </Link>

                        </div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li class="breadcrumb-item active" aria-current="page"><Link to="/rules">Rules Tests</Link></li>
                            <li class="breadcrumb-item active" aria-current="page">Manage Question</li>
                        </ol>
                    </nav>




                <div>
                    <div class="containers" style={{overflow:'auto'}}>


                {result?
                <table class="table table-rules">
                    <thead>
                        <tr className="rules-table-head">
                        <th scope="col">Sl.No</th>
                        <th scope="col">Questions</th>
                        <th scope="col">Type</th>
                        <th scope="col">Points</th>
                        <th></th>

                        </tr>
                    </thead>
                    {                   
                        result?.map((item,index) =>(
                            <tbody className="rules-table-content">

                        <tr>
                        <td>{sl++}</td>
                        <td className="col-md-6">{decode(item.question)}</td>
                        <td>{item.type === 'BOOLEAN'? 'TRUE/FALSE' : item.type}</td>
                        <td>{item.mark}</td>
                        <td>
                        <div className="list-action-wrpr showicons roundicons-text">
                        <div className="list-action-wrpr">
                        <button style={{top:"-20px"}} onClick={()=>navigate("/editRuleQuestion/"+id+'/'+item.id)} data-toggle="tooltip" title="Edit">
                            <i class="edit icon-pencil3"></i>
                            <span>Update</span>
                        </button>
                        <button  style={{top:"-20px"}} data-toggle="tooltip" onClick={()=> { DeleteQuestion(item.id) } } className="delteprof" title="Delete" id={id}>
                            <i class="delete icon-close1"></i>
                            <span>Delete</span>
                        </button>
                    </div>
                    </div>
                        </td>
                        </tr>


                    </tbody>

                        ))               
                    }



                        <tr>
                        <td></td>
                        <td style={{fontWeight:700, fontFamily:'Montserrat'}}>Total Points</td>
                        <td></td>
                        <td style={{fontWeight:700, fontFamily:'Montserrat'}}>{tmark}</td>
                        <td></td>
                        </tr>
                        








                </table>:null}


                </div>
                </div>

                {
                    !result?
                    <div style={{marginTop:'10%'}}>
                        <div className="nodata empty-workshop">
                            <Link to={"/create_quest/"+id}  data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add Question</span> </Link>
                        </div>
                    </div>:null
                }

                <div className="list-action-wrpr showicons roundicons-text">
                    <div className="list-action-wrpr">
                        {/* <Link  to={"/edit_rules/"+id} data-toggle="tooltip" title="Edit">
                            <i class="edit icon-pencil3"></i>
                            <span>Update</span>
                        </Link> */}
                        {/* <button data-toggle="tooltip" className="delteprof" title="Delete" id={id}>
                            <i class="delete icon-close1"></i>
                            <span>Delete</span>
                        </button> */}
                    </div>
                </div>


                </div>

                
            </aside>
        </div>

    </>)
}

export default RulesQuestionList